import type { ItemsResponse } from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"
import { POSITION_DESER, Position } from "../../tastyworks/position"

export class AccountPositionsService {
  constructor(private readonly accountNumberClient: HttpClient) {}

  readonly getEventContractPositions = async (
    accountNumber: string
  ): Promise<ItemsResponse<Position>> =>
    // `include-closed-positions=true` so closed-today rows are present in
    // the snapshot after a hard reload (boule re-emits them via streamer
    // mid-session, but a fresh load only sees what REST returned). The
    // Svelte "Closed" filter governs whether they're rendered.
    this.accountNumberClient.indexSimple(
      POSITION_DESER.toParser(Position),
      "positions",
      {
        accountNumber,
        instrumentType: "Event Contract",
        includeClosedPositions: true,
      }
    )
}
